import { Skeleton } from "@/app/components/shadcn/skeleton";
import { cn } from "@/app/utils/cn";

interface PhoneInputSkeletonProps {
  className?: string;
}

const PhoneInputSkeleton = ({ className }: PhoneInputSkeletonProps) => {
  return (
    <div className={cn("relative flex w-full h-12", className)}>
      {/* Country Code Skeleton */}
      <div className="flex items-center gap-2 rounded-l-md border border-r-0 border-input bg-transparent px-3 py-1 shadow-xs h-12">
        <Skeleton className="h-4 w-6" />
        <Skeleton className="h-4 w-12" />
        <Skeleton className="h-3 w-3" />
      </div>
      {/* Phone Input Skeleton */}
      <div className="w-full min-w-0 rounded-l-none rounded-r-md border border-input bg-transparent px-3 py-1 shadow-xs h-12 flex items-center">
        <Skeleton className="h-4 w-32" />
      </div>
    </div>
  );
};

export default PhoneInputSkeleton;